
  import CoolLightBox from "vue-cool-lightbox";
  import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
  import PremiumCoupon from '@/components/PremiumCoupon'
  import CheckoutModal from '@/components/modals/CheckoutModal';
  import ShimmerDetailV2 from '@/components/ShimmerDetailV2';
  import ShimmerEffect from "@/components/ShimmerEffect.vue";
  export default {
    components: {
      PremiumCoupon,
      CheckoutModal,
      ShimmerDetailV2,
      ShimmerEffect,
      CoolLightBox
    },
    head() {
      return {
        title: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App',
        meta: [{
            hid: 'description',
            name: 'description',
            content: this.metaDesc()
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content: this.metaKeywords()
          },
          {
            hid: 'image',
            property: 'image',
            content: this.metaImage()
          },
          {
            hid: 'og:title',
            property: 'og:title',
            content: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App',
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.metaImage()
          },
          {
            hid: 'og:image:secure_url',
            property: 'og:image:secure_url',
            content: this.metaImage()
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: this.metaDesc()
          },
          {
            hid: 'twitter:title',
            property: 'twitter:title',
            content: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App',
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content: this.metaDesc()
          }
        ],
      }
    },
    data() {
      return {
        pageSlug: null,
        seoData: null,
        index: null,
        menuIndex: null,
        listings: null,
        loading: true,
        offerLoading: true,
        offerDataForModal: null,
        token: null,
        offerCode: null,
        toBeAddedToCart: null,
        addToCartLoading: false,
        redeemOfferLoading: false,
        redeemOfferSuccess: false,
        redeemOfferErr: null,
        selectedOffer: -1,
        selectedSec: 'about',
      };
    },
    async validate({
      params,
      store
    }) {
      // await operations
      if (params.slug != (null || "")) {
        this.pageSlug = params.slug;
        return true // if the params are valid
      } else {
        return false // will stop Nuxt.js to render the route and display the error page
      }
    },
    created() {
      this.pageSlug = this.$route.params.slug;
      this.$fetch();
    },
    async fetch() {
      this.seoData = await fetch(this.$config.fetchUrl + '/api/offers/seo/getSEOContent/' + this.pageSlug)
        .then(res => res.json()).catch(error => {
          console.error("There was an error!", error); return false;
        });
    },
    mounted() {
      this.getPageData();
    },
    methods: {
      async getPageData() {
        //Get the list of post data
        if (localStorage.getItem("authToken") != (null || undefined)) {
          this.token = localStorage.getItem("authToken");
          const headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': this.token,
          }
          // AXIOS api call to add SIGNIN api
          this.$axios
            .get('/api/offers/user/' + this.pageSlug, {
              headers: headers
            })
            .then(response => {
              // New flow
              this.$nextTick(() => {
                this.populateData(response.data);
              })
            })
        } else {
          this.listings = await fetch(this.$config.fetchUrl + '/api/offers/' + this.pageSlug)
            .then(res => res.text()).catch(error => {
              console.error("There was an error!", error); return false;
            });
          this.$nextTick(() => {
            this.populateData(this.listings);
          })
        }
      },
      populateData(data) {
        this.listings = this.getCryptKey(data);
        this.$nextTick(() => {
          this.loading = false;
          this.offerLoading = false;
        })
      },
      metaDesc() {
        if (this.seoData && this.seoData.description) {
          return this.seoData.description
        } else {
          return 'Looking for the must visit places and must do activities in Goa ? Goa App offers all that you need to know about the Beaches, Old Goa Churches Dudhsagar Waterfalls Tour, Parasailing, Watersports Activities, Scuba Diving, Grand Island Tour, Car Rentals etc. Check out the top things to do in Goa only on Goa App.'
        }
      },
      metaKeywords() {
        if (this.seoData && this.seoData.keywords) {
          return this.seoData.keywords;
        } else {
          return 'Goa, Goa Tourism, Travel Guide, Watersports, must visit places, Must do activities, Watesports, Scuba diving, Parasailing, Dudhsagar Waterfalls Tour, Grand Island Goa, Cheap, Discount, Old Goa Churches, Offers, Travel Goa, Visit goa, Car rentals, Bike Rentals, Top things to do in Goa, Travel Agency'
        }
      },
      metaImage() {
        if (this.seoData && this.seoData.image) {
          return this.seoData.image;
        } else {
          return 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-12-14T06%3A34%3A55.402Zbeaches.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=L%2FFNG4DzwiyU1H%2BoK2pdHPxA4qkomya%2BxGZmJq2vCtr7Y4l74qnAn8Tk8Cz1mUNsV%2F7%2FEAKRpl0thh8wvSgb8vqvaA3Wk0TO%2FLp%2FRbqF5wDyixmv90TsYvNguZQAx0BmaE9W0AMQNOiVWG5AfYa2pyyyYhYO6Z3aXQ25biU1%2BjjYZ8NMto47ea4UuyC2btEEDU1IK9GivCXtxlcFDC3xEC80EbMub0mIowfGV2EQ0Nr3Dm0kOLurIx5jy%2Ba1oVAB2Eu3MzLIp%2B1Nm%2BnleN%2FaHTp5pWmj2y7VNqbjtA8wcw94Q1rL1b7FXSsHuxBmNABsdt3INpqGVpT%2BhO2G7iphbg%3D%3D'
        }
      },
      getLatLongForMap() {
        if (this.listings && this.listings.post && this.listings.post.location && this.listings.post.location
          .latitude && this.listings.post.location.longitude) {
          return this.listings.post.location.latitude + "," + this.listings.post.location.longitude
        }
        return ""
      },
      getTermsArr(terms) {
        let arr = terms.split("\n")
        arr = arr.filter(item => item);
        return arr
      },
      // Store filters in Localstorage
      scrollHere(item) {
        this.$nextTick(() => {
          this.scrollToJsOffers(item)
        })
      },
      // Login Functionalities
      userCreated() {
        this.offerLoading = true;
        this.getPageData();
        if (this.toBeAddedToCart)
          this.addOfferToCart(this.toBeAddedToCart)
      },
      unlockOfferClick(addItemToCart) {
        if (localStorage.getItem("authToken") != (null || undefined)) {
          this.token = localStorage.getItem("authToken");
          console.log('yes')
          this.addOfferToCart(addItemToCart);
        } else {
          this.toBeAddedToCart = addItemToCart;
          this.$bvModal.show('checkout')
          // this.$router.push({
          //   path: '/register/'
          // })
          return
        }
      },
      redeemOfferCall(item) {
        this.redeemOfferErr = null;
        this.redeemOfferSuccess = false;
        if (localStorage.getItem("authToken") != (null || undefined)) {
          this.redeemOfferLoading = true
          // Create formData instance to pass the data to the API
          var formData = new URLSearchParams();
          formData.append("offer", item._id);
          formData.append("pin", this.offerCode);
          // Add header for the API
          const headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': this.token
          }
          // AXIOS api call to add categories api
          this.$axios
            .post(`/api/offers/redeemOffer`, formData, {
              headers: headers
            })
            .then(response => {
              this.toBeAddedToCart = null;
              this.offerCode = null;
              let value = this.getCryptKey(response.data);
              if (value.success) {
                this.getPageData();
                this.redeemOfferSuccess = true;
              } else {
                this.redeemOfferErr = value.message
              }
            })
            .catch(error => {
              localStorage.clear();
              this.$router.push({
                path: "/accounts/login"
              });
            })
            .finally(() => {
              this.redeemOfferLoading = false;
            });
        } else {
          this.toBeAddedToCart = null;
          this.$bvModal.show('checkout')
        }
      },
      addOfferToCart(item) {
        this.addToCartLoading = true
        // Create formData instance to pass the data to the API
        var formData = new URLSearchParams();
        formData.append("offer", item._id);
        // Add header for the API
        const headers = {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': this.token
        }
        // AXIOS api call to add categories api
        this.$axios
          .post(`/api/offerCarts/app/v2/addToOfferCart`, formData, {
            headers: headers
          })
          .then(response => {
            console.log("d", response)
            let value = this.getCryptKey(response.data);
            this.$router.push({
              path: "/offers"
            });
            // this.itemAddToCart = true;
            this.addToCartLoading = false;
            // this.bookingLoading = false;
            // this.bookingSubmit.success = true
            // setTimeout(() => {
            //   this.bookingSubmit.success = false;
            // }, 2000)
            // this.bookingSubmit.errored = false;
            // //document.getElementById('bookingClose').click();
            // if (isAddToCart) {
            //   if (this.bookFromFlaotingBtn) {
            //     this.$router.push({
            //       path: "/checkout"
            //     });
            //     this.bookFromFlaotingBtn = false;
            //     this.bookFromFlaotingBtnLoading = false;
            //   }
            //   this.getCartItems();
            // } else {
            //   this.$router.push({
            //     path: "/checkout"
            //   });
            // }
          })
          .catch(error => {
            // this.bookingSubmit.success = false
            // this.bookingSubmit.errored = true
            this.addToCartLoading = false;
            // this.bookingLoading = false;
            localStorage.clear();
            this.$router.push({
              path: "/accounts/login"
            });
          })
          .finally(() => {
            this.addToCartLoading = false;
          });
      }
    }
  }
